import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectNative } from '../../../common/Form';
import DatePickerCmp from '../../../common/DatePicker';
import { GroupCheckbox, GroupRadio, GroupSwitch, SingleCheckbox, SingleRadio, SingleSwitch } from '../../../common/RadioAndCheckbox';
import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import Creatable from '../../../common/Creatable';
import { Fragment } from 'react';
import PhotoUpload from '../../../common/PhotoUpload';

class EquipementPics extends Component {
    state = { 
        equipement_photo_front: null,
        equipement_photo_back: null,
        equipement_photo_top: null,
        equipement_photo_bottom: null,
        equipement_photo_left: null,
        equipement_photo_right: null,
        errors:{}
    }

    componentDidMount = () => {
        const { equipement } = this.props;
        console.log('====================================');
        console.log({equipement});
        console.log('====================================');
    }

    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }
    validate = () => {
        let noError = true
        let errors = {} 
        // let required = [
        //     "equipement_photo_front",
        //     "equipement_photo_back",
        //     // "equipement_photo_top",
        //     // "equipement_photo_bottom",
        //     "equipement_photo_left",
        //     "equipement_photo_right",
        // ]

        // required.map(field => {
        //     if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
        //         console.log(`${field} is empty`)
        //         noError =  false
        //         errors[field] = "Veuillez remplir ce Champ" 
        //     } else {
        //         errors[field] = "" 
        //     }
        // })

        this.setState({
            errors
        })
        return noError
    }

    handleSubmit = async () => {

        if( this.validate() ){
            let data = Object.assign({}, this.props.equipement)
            data.equipement_photo_front = this.state.equipement_photo_front
            data.equipement_photo_back = this.state.equipement_photo_back
            data.equipement_photo_top = this.state.equipement_photo_top
            data.equipement_photo_bottom = this.state.equipement_photo_bottom
            data.equipement_photo_left = this.state.equipement_photo_left
            data.equipement_photo_right = this.state.equipement_photo_right

            if(this.props.type === "vehicule"){
                await this.props.updateVehiculePics(data)
            } else {
                await this.props.updateEquipementPics(data)
                // await this.props.updateEquipement(data)
            }
            // // if NoErrors ...
            if(this.props.STATE.equipements.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.equipements.error}`)
            } else { 
                this.props.notif("success", "l'équipement a été modifié")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { CATEGORIES, LOCALISATIONS, update, equipement } = this.props;
        console.log('====================================');
        console.log(this.state, this.props.equipement);
        console.log('====================================');
        return (
            <Dialog
                title={"Modifier l'équipement"}
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
                appBar
                maxWidth="md"
            >
                {!isEmpty(this.props.equipement) &&
                <Grid container >
                    <Grid item xs={12}>
                        <Box p={1}>
                            <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Photos</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <PhotoUpload saved={equipement.equipement_photo_front && `/photos/single/${equipement.equipement_photo_front.filename}`} id="front" label="Photo Face Avant" setPhoto={(pic) => this.setPhotos("equipement_photo_front", pic)} photos={this.state.equipement_photo_front === null ? [] : this.state.equipement_photo_front } error={this.state.errors.equipement_photo_front} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <PhotoUpload saved={equipement.equipement_photo_back && `/photos/single/${equipement.equipement_photo_back.filename}`} id="back" label="Photo Face Arrière" setPhoto={(pic) => this.setPhotos("equipement_photo_back", pic)} photos={this.state.equipement_photo_back === null ? [] : this.state.equipement_photo_back } error={this.state.errors.equipement_photo_back} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <PhotoUpload saved={equipement.equipement_photo_left && `/photos/single/${equipement.equipement_photo_left.filename}`} id="left" label="Photo Face Gauche" setPhoto={(pic) => this.setPhotos("equipement_photo_left", pic)} photos={this.state.equipement_photo_left === null ? [] : this.state.equipement_photo_left } error={this.state.errors.equipement_photo_left} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <PhotoUpload saved={equipement.equipement_photo_right && `/photos/single/${equipement.equipement_photo_right.filename}`} id="right" label="Photo Face Droite" setPhoto={(pic) => this.setPhotos("equipement_photo_right", pic)} photos={this.state.equipement_photo_right === null ? [] : this.state.equipement_photo_right } error={this.state.errors.equipement_photo_right} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <PhotoUpload saved={equipement.equipement_photo_top && `/photos/single/${equipement.equipement_photo_top.filename}`} id="top" label="Photo Haut" setPhoto={(pic) => this.setPhotos("equipement_photo_top", pic)} photos={this.state.equipement_photo_top === null ? [] : this.state.equipement_photo_top } error={this.state.errors.equipement_photo_top} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <PhotoUpload saved={equipement.equipement_photo_bottom && `/photos/single/${equipement.equipement_photo_bottom.filename}`} id="bottom" label="Photo Bas" setPhoto={(pic) => this.setPhotos("equipement_photo_bottom", pic)} photos={this.state.equipement_photo_bottom === null ? [] : this.state.equipement_photo_bottom } error={this.state.errors.equipement_photo_bottom} />
                        </Box>
                    </Grid>
                </Grid>      
                }
            </Dialog>
        );
    }
}

export default EquipementPics;